<template>
  <VContainer>
    <h1 class="mt-10 mb-4 font-bold text-2xl border-b pb-1">{{ $t('Search') }}</h1>
    <VProductListing :searchInput="true" />
  </VContainer>
</template>
